import React, { createContext, useState, useContext, useEffect } from "react";
import customHttp from "../services/customHTTP"; // Import customHttp
import { useLocation, useNavigate } from "react-router-dom";
// Create the context
const OptionsContext = createContext();

// Custom hook to use the context
export const useOptions = () => useContext(OptionsContext);

const OptionsProvider = ({ children }) => {
	const navigate = useNavigate();
	const [options, setOptions] = useState(null);
	const [optionKeys, setOptionKeys] = useState(null);
	const [selectedTheme, setSelectedTheme] = useState(null);
	const [mfaDays, setMfaDays] = useState(null);
	const [mfaEnabled, setMfaEnabled] = useState(null);

	const convertBoolean = (value) => value === "true";

	const fetchOptions = async () => {
		console.log("Fetching Options");
		try {
			const response = await customHttp.get("options");
			console.log("Options: ", response);
			if (response.data.success) {
				const opts = response.data.data;
				setOptionKeys(response.data.options);
				setOptions(response.data.data);
				setMfaDays(parseInt(opts.find((item) => item.option_key === "mfaDays")?.option_value) || 15);
				setMfaEnabled(
					opts.find((item) => item.option_key === "mfaEnabled")?.option_value === "Enabled" ? true : false
				);
				setSelectedTheme(opts.find((item) => item.option_key === "theme")?.option_value || "blue");
			}
		} catch (error) {
			console.log("Error fetching Options: ", error);
		}
	};

	const setOption = async (options) => {
		try {
			const resp = await customHttp.post("options/insert", { options });
			if (resp.data.status) {
				console.log("Option Updated", options);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getOption = async (option_key) => {
		try {
			const resp = await customHttp.post("options/get-by-key", { option_key });
			if (resp.data.success) {
				console.log("Option Found", options);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		fetchOptions();
	}, []);

	return (
		<OptionsContext.Provider
			value={{
				options,
				selectedTheme,
				mfaDays,
				mfaEnabled,
				setOption,
				getOption,
			}}>
			{children}
		</OptionsContext.Provider>
	);
};

export default OptionsProvider;
